import React from "react";
import { Link } from "react-router-dom";
import { LogoLockup } from "@/components/Logo";
import { Home } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-[var(--tm-off)] text-[#0F1115] flex flex-col items-center justify-center p-8">
      <LogoLockup />
      <div className="mt-8 text-center max-w-md">
        <div className="text-[11px] uppercase tracking-[0.2em] text-[var(--tm-gold)] font-semibold">Error 404</div>
        <h1 className="mt-2 text-3xl sm:text-4xl font-bold">We couldn't find that page.</h1>
        <p className="mt-3 text-sm text-[#3B424B]">
          The URL you followed might be broken, or the page may have moved. Head back to your dashboard to keep going.
        </p>
        <Link
          to="/app"
          className="tm-btn-primary mt-6 inline-flex items-center gap-2 h-11 px-5"
          data-testid="notfound-home"
        >
          <Home size={14} /> Back to dashboard
        </Link>
      </div>
    </div>
  );
}
